import * as stytch from "stytch";

let client: stytch.B2BClient;

export const publicToken = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN;

export type Member = Awaited<
  ReturnType<typeof client.magicLinks.authenticate>
>["member"];
export type Organization = Awaited<
  ReturnType<typeof client.organizations.get>
>["organization"];
export type SessionsAuthenticateResponse = Awaited<
  ReturnType<typeof client.sessions.authenticate>
>;
export type SAMLConnection = Awaited<
  ReturnType<typeof client.sso.saml.createConnection>
>["connection"];

export type OIDCConnection = Awaited<
  ReturnType<typeof client.sso.oidc.createConnection>
>["connection"];

export type DiscoveredOrganizations = Awaited<
  ReturnType<typeof client.discovery.organizations.list>
>["discovered_organizations"];

const stytchEnv =
  process.env.NEXT_PUBLIC_STYTCH_PROJECT_ENV === "live"
    ? stytch.envs.live
    : stytch.envs.test;

function formatCallbackUrl(redirectDomain: string): string {
  const baseUrl =
    redirectDomain || process.env.NEXT_PUBLIC_URL || "http://localhost:3000";
  return new URL("/callback", baseUrl).toString();
}

export const formatSSOStartURL = (
  redirectDomain: string,
  connection_id: string,
): string => {
  const redirectURL = formatCallbackUrl(redirectDomain);
  return `${stytchEnv}v1/public/sso/start?connection_id=${connection_id}&public_token=${publicToken}&login_redirect_url=${redirectURL}&signup_redirect_url=${redirectURL}`;
};

// No need to worry about CNames for OAuth Start URL's as Stytch will automatically redirect to the registered CName
export const formatOAuthDiscoveryStartURL = (
  redirectDomain: string,
  provider: string,
  scopes: string[] = [],
  additionalParams: Record<string, string> = {},
): string => {
  const redirectURL = formatCallbackUrl(redirectDomain);
  return `${stytchEnv}v1/b2b/public/oauth/${provider}/discovery/start?public_token=${publicToken}&discovery_redirect_url=${redirectURL}&custom_scopes=${encodeURIComponent(scopes.join(" "))}&${new URLSearchParams(additionalParams).toString()}`;
};

export const formatOAuthStartURL = (
  redirectDomain: string,
  provider: string,
  org_slug: string,
  customScopes?: string[],
): string => {
  const redirectURL = formatCallbackUrl(redirectDomain);
  let baseUrl = `${stytchEnv}v1/b2b/public/oauth/${provider}/start?public_token=${publicToken}&slug=${org_slug}&login_redirect_url=${redirectURL}&signup_redirect_url=${redirectURL}`;

  // Add custom scopes if provided
  if (customScopes && customScopes.length > 0) {
    baseUrl += `&custom_scopes=${encodeURIComponent(customScopes.join(" "))}`;
  }

  // Add provider-specific parameters for Google to ensure we get refresh tokens and consent
  if (provider === "google") {
    baseUrl +=
      "&access_type=offline&prompt=consent&include_granted_scopes=true";
  }

  return baseUrl;
};
